import {activateMobileAmenityOverlay} from "@Reducers/mobileSlice";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";

/**
 * Opens amenity selection screen.
 * Handles web vs mobile flow.
 */
export default function useOpenAmenitiesSelectionScreen(groupKey: string, openModal: () => void, isUpdating: boolean) {
    const isMobile = useIsMobile()
    const dispatch = useAppDispatch()

    const openAmenities = () => {
        if (isUpdating) {
            return
        }
        if (isMobile) {
            dispatch(activateMobileAmenityOverlay(groupKey))
        } else {
            openModal()
        }
    }

    return {
        openAmenities,
    }
}